import { Stack } from '@mui/material';
import { FlowGetEncounterMode } from 'flow-schema';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockRadioGroupField } from '../../../ConfigFields/RadioGroupField';
import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

export function EncounterFormFields() {
  const { value: mode = FlowGetEncounterMode.FindAll } =
    useSelectedNodeField<FlowGetEncounterMode>('config.mode');

  return (
    <Stack gap={2}>
      <BlockRadioGroupField
        fieldName="config.mode"
        label="Mode"
        row
        defaultValue={FlowGetEncounterMode.FindAll}
        options={[
          {
            label: 'Find all for patient',
            value: FlowGetEncounterMode.FindAll,
          },
          {
            label: 'Get one by encounter ID',
            value: FlowGetEncounterMode.GetOneById,
          },
        ]}
      />

      {mode === FlowGetEncounterMode.GetOneById && (
        <BlockValueTemplateField
          fieldName="config.encounterId"
          label="Encounter ID"
          helperText="Enter the reference to the Encounter ID. e.g. `{{start.data.encounterId}}`"
          placeholder="e.g. {{start.data.encounterId}}"
        />
      )}

      {mode === FlowGetEncounterMode.FindAll && (
        <>
          <ParentBlockSelectField
            fieldName="config.patient.sourceBlockName"
            label="Patient Source"
            required
            helperText={getSourceBlockNameHelperText('patient')}
          />
          <BlockValueTemplateField fieldName="config.startDate" label="Start Date" />
          <BlockValueTemplateField fieldName="config.endDate" label="End Date" />
        </>
      )}
    </Stack>
  );
}
